import { SubmitScanPointNew } from "./Module/Customer";
import { isNewApiEnabled } from "./customerProfileFetch";

function extractResponseData(res) {
  return res?.data ?? res?.response?.data;
}

export async function submitScanPointWithFallback({ data }) {
  const _return = {
    status: false,
    result: null,
    source: "new",
    error: null,
  };

  if (!isNewApiEnabled()) {
    _return.error = { message: "New API is not enabled" };
    return _return;
  }

  try {
    const res = await SubmitScanPointNew({ data });
    const responseData = extractResponseData(res);

    if (responseData?.resultCode === "20000") {
      return {
        status: true,
        result: responseData.resultData,
        source: "new",
        error: null,
      };
    }

    _return.error = responseData;
    console.log("[scanPoint] new API non-success >>", responseData);
  } catch (e) {
    console.log("[scanPoint] new API failed >>", e);
    _return.error = e?.response?.data || e;
  }

  return _return;
}
